import React from 'react';
import { Button, Grid, GridCell, Heading, Text } from '@flixbus/honeycomb-react';

const ErrorMessage = () => (
    <Grid extraClasses="hcr-space-8-top">
        <GridCell colSpan={12} extraClasses="hcr-has-text-centered">
            <Heading size={2}>Something went wrong</Heading>
            <Text>An unexpected error occurred. Please reload the page.</Text>
            <Button appearance="primary" extraClasses="hcr-space-4-top" onClick={() => window.location.reload()}>
                Reload page
            </Button>
        </GridCell>
    </Grid>
);

// Catches render errors only (instead of a blank page); API errors are shown as toasts (useErrorNotification).
class ErrorBoundary extends React.Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error(error, info.componentStack);
    }

    render() {
        return this.state.hasError ? <ErrorMessage /> : this.props.children;
    }
}

export default ErrorBoundary;
